// Scripting for sliders or carousels
(function($){
	$('.home-hero-slider').each(function(){
		//Count the slides
		let count = $(this).find('.card').length;

		$(this).toggleClass('centre-slides-desktop', count <= 3);

		$(this).slick({
			dots: false,
			variableWidth: true,
			adaptiveHeight: false,
			prevArrow: '<a class="arrow arrow-prev"><i class="far fa-chevron-left"></i></a>',
			nextArrow: '<a class="arrow arrow-next"><i class="far fa-chevron-right"></i></a>',
			infinite: count > 3,
			autoplay: count > 3,
			autoplaySpeed: 4000,
			pauseOnHover:true,
			speed: 400,
			responsive: [
				{
					breakpoint: 1400,
					settings: {
						infinite: count > 2,
						autoplay: count > 2,
					}
				},
				{
					breakpoint: 1000,
					settings: {
						infinite: count > 1,
						autoplay: count > 1,
					}
				}
			]
		});
	});
})(jQuery);
